import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/siteData';

export default function SafetyFAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenFAQ(openFAQ === idx ? null : idx);
  };

  return (
    <>
      <section id="safety" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center max-w-[1100px] mx-auto">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20laptop%20displaying%20security%20verified%20badges%20on%20screen%2C%20warm%20cream%20beige%20background%2C%20soft%20peaceful%20natural%20lighting%2C%20trust%20and%20safety%20concept%2C%20small%20potted%20plant%20on%20desk%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography%2C%20secure%20protected%20digital%20environment&width=800&height=600&seq=vigorbuy-safety-v2&orientation=landscape"
                alt="Safe and secure Vigorbuy Spreadsheet usage environment"
                title="Vigorbuy Spreadsheet Safety Guide"
                className="w-full h-auto rounded-2xl"
              />
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
                Is Vigorbuy Spreadsheet Safe?
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                Vigorbuy Spreadsheet is a resource-based tool that helps users organize product information. It does not collect personal data or process payments directly.
              </p>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                Users should always verify links, protect personal information and use trusted sources before making purchasing decisions. We recommend reviewing our complete safety guide for detailed recommendations.
              </p>
              <Link
                to="/article/vigorbuy-spreadsheet-safety-guide"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap"
              >
                Read Complete Safety Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              Quick answers to common questions about Vigorbuy Spreadsheet.
            </p>
          </div>

          <div className="max-w-[750px] mx-auto flex flex-col gap-3">
            {faqItems.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openFAQ === idx ? 'bg-primary-100 rotate-180' : 'bg-background-200'}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500 text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openFAQ === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 text-center">
          <div className="max-w-[650px] mx-auto bg-secondary-50 border border-secondary-200/60 rounded-2xl p-8 md:p-10">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
              Ready to Master Vigorbuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-6">
              Dive into our comprehensive beginner guide and learn everything you need to know about using Vigorbuy Spreadsheet effectively.
            </p>
            <Link
              to="/article/vigorbuy-spreadsheet-beginner-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap"
            >
              Read the Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}